import { useQuery } from '@tanstack/react-query';
import { eventsQueryKey } from 'queries/events/queryKey';
import { EventApi } from 'api/ApiHelper';

export const useGetEventParticipatedQuery = (eventId: number, enabled = false) =>
  useQuery({
    queryKey: eventsQueryKey.eventParticipated(eventId),
    queryFn: () => EventApi.getEventParticipated(eventId),
    enabled,
  });
